import moment from 'moment';

export default function validationCriteresRecherche(criteresRecherche, errors) {
  if (criteresRecherche.dates
    && moment(criteresRecherche.dates.dateDebut).isAfter(criteresRecherche.dates.dateFin)) {
    errors.push({ message: 'listeAudit.filtre.error.dates' });
  }
  if (criteresRecherche.datesPremierAffichage
    && moment(criteresRecherche.datesPremierAffichage.dateDebut)
      .isAfter(criteresRecherche.datesPremierAffichage.dateFin)) {
    errors.push({ message: 'listeAudit.filtre.error.datesPremierAffichage' });
  }
  if (criteresRecherche.datesValidite
    && moment(criteresRecherche.datesValidite.dateDebut)
      .isAfter(criteresRecherche.datesValidite.dateFin)) {
    errors.push({ message: 'listeAudit.filtre.error.datesValidite' });
  }
}
